import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VaIconModule } from '../../va-icon/icon.module';
import { VaButtonComponent } from './va-button.component';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    VaIconModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    GalaxyTooltipModule,
  ],
  declarations: [VaButtonComponent],
  exports: [VaButtonComponent],
})
export class VaButtonModule {}
